const unitScaleMap = {
  '-12': 'f',
  '-9': 'n',
  '-6': 'u',
  '-3': 'm',
  // 0: 'bps',
  3: 'k',
  6: 'M',
  9: 'G',
  12: 'T',
  15: 'P',
  18: 'E',
  21: 'Z',
  24: 'Y',
};

type ToUnitsOptions = {
  base?: number;
  mode?: 'large' | 'all';
};

export const toUnits = (
  input: number | string,
  unit: string,
  options?: ToUnitsOptions,
): string => {
  const base = options?.base || 1000;
  const mode = options?.mode || 'large';

  if (typeof input === 'string') {
    input = parseFloat(input);
  }

  if (input === 0) {
    return `0 ${unit}`;
  }

  const negative = input < 0;
  const sign = negative ? '-' : '';

  if (negative) {
    input = Math.abs(input);
  }

  const i = Math.floor(Math.log(input) / Math.log(base));

  if (i === 0 || (input < 1 && mode === 'large')) {
    return `${sign}${input.toFixed(2)} ${unit}`;
  }

  const unitKey = `${i * 3}` as keyof typeof unitScaleMap;

  if (unitKey in unitScaleMap) {
    return `${sign}${(input / Math.pow(base, i)).toFixed(2)} ${
      unitScaleMap[unitKey]
    }${unit}`;
  }

  return `${sign}${input} ${unit}`;
};
